import ApiRouteProvider from '@core/api/route'
import axios from '@axios'

export default {
    getCounters() {
        return axios.get(`${ApiRouteProvider.getBaseUrl()}/stats/counters`)
    },

    getProductStats(id) {
        return axios.get(`${ApiRouteProvider.getBaseUrl()}/stats/product/${id}`)
    },

    getSubstanceProducts(substanceId, page, perPage) {
        return axios.get(`${ApiRouteProvider.getBaseUrl()}/stats/substance/${substanceId}/products`, {
            params: {
                page,
                perPage,
            },
        })
    },

    getProductSubstanceComponents(productId, substanceId, page, perPage) {
        return axios.get(`${ApiRouteProvider.getBaseUrl()}/stats/product/${productId}/substance/${substanceId}/components`, {
            params: {
                page,
                perPage,
            },
        })
    },
}
